import { Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy, inject } from "@angular/core";
import { INotification, NotificationStatus } from "../notification.models";
import { CharTypeId } from "../../../rl-common.consts";
import { DateTimeFormatType } from "../../../utils";
import { Subscription } from "rxjs";
import { NotificationService } from "../notification.service";

import { CharTypeNamePipe } from "../../../pipes/char-type-name.pipe";
import { LocalDatePipe } from "../../../pipes/local-date.pipe";

@Component({
    selector: "rl-notification-modal",
    templateUrl: "./notification-modal.component.html",
    styleUrls: ["./notification-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CharTypeNamePipe, LocalDatePipe]
})
export class NotificationModalComponent implements OnDestroy {
	private readonly _notificationService = inject(NotificationService);


	@Input()
	charTypeId: CharTypeId;

	@Input()
	notification: INotification;

	@Output()
	markedAsRead = new EventEmitter<boolean>();

	markingAsRead = false;

	private readonly _subscriptions: Subscription[] = [];

	DateTimeFormatType = DateTimeFormatType;

	get isUnread() {
		return this.notification.status !== NotificationStatus.Read;
	}

	markAsRead() {
		this.markingAsRead = true;
		const sub = this._notificationService.setNotificationStatus(this.charTypeId, [this.notification.id], NotificationStatus.Read).subscribe(() => {
			this.markingAsRead = false;
			this.markedAsRead.next(true);
		});
		this._subscriptions.push(sub);
	}

	close() {
		this.markedAsRead.next(false);
	}

	ngOnDestroy() {
		this._subscriptions.forEach(sub => sub.unsubscribe());
	}

}
